import React, { useEffect } from 'react';

import { CategoryFields } from '__generated__/CategoryFields';
import { SquareOnlineStoreProjectType } from '__generated__/types';
import { Currency } from 'common/utils/currency';
import BudgetField from 'projects/components/BriefFields/BudgetField';
import TimeframeField from 'projects/components/BriefFields/TimeframeField';
import PriceGuide from 'projects/components/BudgetSlider/PriceGuide';
import { ObservableForm } from 'projects/components/ObservableForm';
import { trackViewedBriefEvent } from 'projects/events';
import { minPriceForProjectType } from './helpers';

type Fields = React.ComponentProps<typeof TimeframeField>['form']['data'] &
    React.ComponentProps<typeof BudgetField>['form']['data'] & {
        projectType: SquareOnlineStoreProjectType;
    };

export interface Props<T> {
    form: ObservableForm<T>;
    brief: {
        id: string;
        category: CategoryFields | null;
    };
}

const TimeAndBudgetPage: <T extends Fields>(props: Props<T>) => React.ReactElement<Props<T>> = ({
    form,
    brief,
}) => {
    useEffect(() => {
        trackViewedBriefEvent({
            id: brief.id,
            page: 'TimeAndBudget',
        });
    }, []);

    return (
        <div className="content-setting">
            <TimeframeField form={form} />
            <BudgetField
                form={form}
                currency={Currency.USD}
                priceGuide={
                    <PriceGuide
                        min={minPriceForProjectType(form.data.projectType)}
                        currency={Currency.USD}
                    />
                }
            />
        </div>
    );
};

export default TimeAndBudgetPage;
